import call from "@brainspore/celadon-base/service/http";
import constants from "./constants";

export default {
  namespaced: true,
  state: {
    reinstatements: [],
    reinstatementInvoice: "",
  },
  mutations: {
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
  },
  getters: {
    reinstatementGetters: (state) => (value) => state[value],
  },
  actions: {
    getReinstatements({ commit }) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", constants.reinstatements)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", { state: "reinstatements", data: res.data.data });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    applyForReinstatement({ commit, dispatch }) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", constants.reinstatements)
        .then((res) => {
          console.log(res.data.data);
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Successfully applied for reinstatement");
          dispatch("getReinstatements");
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    getReinstatementInvoice: ({ commit }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", constants.REINSTATEMENT_PROFORMA(payload))
        .then((res) => {
          commit("MUTATE", {
            state: "reinstatementInvoice",
            data: process.env.VUE_APP_TEMP_URL + res.data.data[0],
          });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
  },
};
